import { useState, useEffect, useContext, Fragment } from 'react'
import { Box, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material"

import CompanyContext 				from "../context";

import Loading 						from '../../../components/Loading';
import IndicatorCard 				from './IndicatorCard';

const TabIndicators = () => {

	const {indicators, currency, isNotesOpen}	= useContext(CompanyContext)

	const [compareTo, setCompareTo]				= useState('industry')
	const [isLoading, setIsLoading]				= useState(true)

	useEffect(() => {
		if (indicators) setIsLoading(false)
	}, [indicators]) 

	if (isLoading) return (<Loading/>)

	var currentSection = ''

	return (
		<Box paddingBottom={2}>
			<Grid container spacing={1} >

				{indicators && indicators.map((i, index) => {
					const showDivider = currentSection !== i.section
					currentSection = i.section
					
					return (
						<Fragment key={i.section +'-'+ i.id}>
							{ showDivider && (
								<Grid item xs={12}>
									<Card variant="outlined" sx={{ position: "relative" }} >
										<CardContent sx={{
											position: "relative",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											height: "100%",
											backgroundColor: 'rgba(0, 0, 0, 0.04)'
											}}>
											<Typography variant="h6" fontWeight={600} sx={{ position: "relative", top: "4px" }}>{i.section}</Typography>
											{ index == 0 && (
												<FormControl	
													sx={{
														position: "absolute",
														right: 16,
														top: "50%",
														transform: "translateY(-50%)", // centraliza verticalmente
														minWidth: 120,
													}}>
													<InputLabel id="select-label">Comparar com: </InputLabel>
													<Select
													 	labelId="select-label"
														id="select"
            											label="Comparar com:"
														size="small"
														value={compareTo}
														onChange={(e) => setCompareTo(e.target.value)}
														>
														<MenuItem value="industry">Segmento</MenuItem>
														<MenuItem value="index">{currency === 'BRL' ? 'IBOV' : 'S&P500'}</MenuItem>
													</Select>
												</FormControl>
											)}
										</CardContent>
									</Card>
								</Grid>
							)}
							<Grid item xs={12} md={isNotesOpen ? 6 : 4} lg={isNotesOpen ? 4 : 3}>
								<IndicatorCard data={indicators} indicator={i.id} compareTo={compareTo}/>
							</Grid>
						</Fragment>
					)}
				)}
			</Grid>
		</Box>
	)
}

export default TabIndicators